/**
 * @generated SignedSource<<8351caa08341b2623eb9f24cd82d3ddd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnCompleteTalkingPointInput = {
  clientMutationId?: string | null;
  talkingPointId: string;
};
export type unCompleteTalkingPointMutation$variables = {
  input: UnCompleteTalkingPointInput;
};
export type unCompleteTalkingPointMutationVariables = unCompleteTalkingPointMutation$variables;
export type unCompleteTalkingPointMutation$data = {
  readonly unCompleteTalkingPoint: {
    readonly talkingPoint: {
      readonly id: string;
      readonly body: string;
      readonly entityId: string;
      readonly creator: {
        readonly avatarUrl: string | null;
        readonly name: string | null;
        readonly viewerIsUser: boolean;
      };
      readonly completedAt: DateString | null;
    } | null;
  } | null;
};
export type unCompleteTalkingPointMutationResponse = unCompleteTalkingPointMutation$data;
export type unCompleteTalkingPointMutation = {
  variables: unCompleteTalkingPointMutationVariables;
  response: unCompleteTalkingPointMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerIsUser",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "unCompleteTalkingPointMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnCompleteTalkingPointPayload",
        "kind": "LinkedField",
        "name": "unCompleteTalkingPoint",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OneOnOneTalkingPoint",
            "kind": "LinkedField",
            "name": "talkingPoint",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "creator",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "unCompleteTalkingPointMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnCompleteTalkingPointPayload",
        "kind": "LinkedField",
        "name": "unCompleteTalkingPoint",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OneOnOneTalkingPoint",
            "kind": "LinkedField",
            "name": "talkingPoint",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "creator",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "621e1729c01106fcf529c204760533b9",
    "id": null,
    "metadata": {},
    "name": "unCompleteTalkingPointMutation",
    "operationKind": "mutation",
    "text": "mutation unCompleteTalkingPointMutation(\n  $input: UnCompleteTalkingPointInput!\n) {\n  unCompleteTalkingPoint(input: $input) {\n    talkingPoint {\n      id\n      body\n      entityId\n      creator {\n        avatarUrl\n        name\n        viewerIsUser\n        id\n      }\n      completedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7de0dc69576d6bf32182683e35315b88";

export default node;
